import { render, staticRenderFns } from "./FiscalStationNumberFSN021001.vue?vue&type=template&id=b17abf52&"
import script from "./FiscalStationNumberFSN021001.vue?vue&type=script&lang=js&"
export * from "./FiscalStationNumberFSN021001.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports